import { render, staticRenderFns } from "./CalcPhisControls.vue?vue&type=template&id=7a665022&scoped=true&"
import script from "./CalcPhisControls.vue?vue&type=script&lang=js&"
export * from "./CalcPhisControls.vue?vue&type=script&lang=js&"
import style0 from "./CalcPhisControls.vue?vue&type=style&index=0&id=7a665022&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a665022",
  null
  
)

export default component.exports